import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "cart-gift__main"
};
var _hoisted_2 = { class: "cart-gift__label" };
var _hoisted_3 = { class: "cart-gift__list" };
var _hoisted_4 = ["href"];
var _hoisted_5 = { class: "prod-line__cover" };
var _hoisted_6 = { class: "prod-line__main" };
var _hoisted_7 = { class: "prod-line__info" };
var _hoisted_8 = { class: "prod-line__brand" };
var _hoisted_9 = { class: "prod-line__name" };
var _hoisted_10 = { class: "prod-line__offer" };
import Picture from "../../../../components/Picture.vue";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GiftsList',
    props: {
        gifts: { type: Array, required: true },
    },
    setup: function (__props) {
        var props = __props;
        var title = computed(function () { return props.gifts.length === 1 ? 'Вы выбрали следующий подарок:' : 'Вы выбрали следующие подарки:'; });
        return function (_ctx, _cache) {
            return (__props.gifts.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(title.value), 1 /* TEXT */),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.gifts, function (gift, key) {
                            return (_openBlock(), _createElementBlock("li", {
                                class: "cart-gift__item",
                                key: key
                            }, [
                                _createElementVNode("a", {
                                    href: gift.url,
                                    class: "prod-line prod-line--extra prod-line--sm"
                                }, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createVNode(Picture, {
                                            picture: gift.image
                                        }, null, 8 /* PROPS */, ["picture"])
                                    ]),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, _toDisplayString(gift.brandName), 1 /* TEXT */),
                                            _cache[0] || (_cache[0] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_9, _toDisplayString(gift.name) + ",", 1 /* TEXT */),
                                            _cache[1] || (_cache[1] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_10, _toDisplayString(gift.offerName), 1 /* TEXT */)
                                        ])
                                    ])
                                ], 8 /* PROPS */, _hoisted_4)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
